export default __webpack_public_path__ + "static/1-db7e928bc8f2513eafadfa2c69d1065d.jpeg";